import { render, staticRenderFns } from "./glstatus.vue?vue&type=template&id=e35a81a8&"
import script from "./glstatus.vue?vue&type=script&lang=js&"
export * from "./glstatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports